module.exports = __webpack_public_path__ + "img/uservip-bg.f3edf666.png";